import React from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import CaretRight from "../../../../../../assets/svg/icons/common/CaretRight";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import useCommonStore from "../../../../../../stores/common";

function Chargebacks() {
  const expandDetails = useCommonStore((state) => state.expandDetails);

  const renderRepresentCell = (data, row) => {
    return (
      <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF">
        Submit
      </ButtonIcon>
    );
  };

  const renderDropDownCell = () => {
    return (
      <ButtonIcon bgColor={"#FF"}>
        <CaretRight />
      </ButtonIcon>
    );
  };

  const renderToRebutCell = (data, row) => {
    return <span className={style.rebut_badge}>{data} day(s)</span>;
  };

  const tableColumns = [
    {
      headerName: "",
      field: "drop_down",
      width: 40,
      allowSort: true,
      renderCell: renderDropDownCell,
    },
    {
      headerName: "Card",
      field: "card",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "Auth. number",
      field: "auth_number",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "Cb Amount",
      field: "cb_amount",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "CB Date",
      field: "cb_date",
      width: 100,
      allowSort: true,
    },
    {
      headerName: "Last Action",
      field: "last_action",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "age",
      field: "age",
      width: 100,
      allowSort: true,
    },
    {
      headerName: "to rebut",
      field: "to_rebut",
      width: 120,
      allowSort: true,
      renderCell: renderToRebutCell,
    },
    {
      headerName: "reason",
      field: "reason",
      width: 480,
      allowSort: true,
    },
    {
      headerName: "Represented",
      field: "represented",
      allowSort: true,
      width: 100,
      renderCell: renderRepresentCell,
    },
  ];

  const data = [
    {
      drop_down: "",
      card: "***3759",
      auth_number: "9000123",
      cb_amount: "$ 200.00",
      cb_date: "10/10/2024",
      last_action: "10/10/2024",
      age: "6",
      to_rebut: "3",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
      represented: "Button",
    },
    {
      drop_down: "",
      card: "***3759",
      auth_number: "9000123",
      cb_amount: "$ 200.00",
      cb_date: "10/10/2024",
      last_action: "10/10/2024",
      age: "6",
      to_rebut: "3",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
      represented: "Button",
    },
    {
      drop_down: "",
      card: "***3759",
      auth_number: "9000123",
      cb_amount: "$ 200.00",
      cb_date: "10/10/2024",
      last_action: "10/10/2024",
      age: "6",
      to_rebut: "3",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
      represented: "Button",
    },
    {
      drop_down: "",
      card: "***3759",
      auth_number: "9000123",
      cb_amount: "$ 200.00",
      cb_date: "10/10/2024",
      last_action: "10/10/2024",
      age: "6",
      to_rebut: "3",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
      represented: "Button",
    },
    {
      drop_down: "",
      card: "***3759",
      auth_number: "9000123",
      cb_amount: "$ 200.00",
      cb_date: "10/10/2024",
      last_action: "10/10/2024",
      age: "6",
      to_rebut: "3",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
      represented: "Button",
    },
  ];

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Chargeback details</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <Table columns={tableColumns} data={data} />
          </div>

          <footer className={style.footer}>
            <Pagination />
          </footer>
        </div>
      )}
    </>
  );
}

export default Chargebacks;
